export enum ChatMessageStatus {
  EDITED = 'EDITED',
  DELETED = 'DELETED',
  SENDING = 'SENDING',
  SENT = 'SENT',
  DELIVERED = 'DELIVERED',
  NOT_DELIVERED = 'NOT_DELIVERED',
  REJECTED = 'REJECTED',
  FAILED = 'FAILED',
  READ = 'READ',
  ERROR = 'ERROR'
}
